// src/components/strumenti/CubaturaScavo.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function CubaturaScavo() {
  const [lunghezza, setLunghezza] = useState("");
  const [larghezza, setLarghezza] = useState("");
  const [profondita, setProfondita] = useState("");
  const [fattoreGonfiamento, setFattoreGonfiamento] = useState("1.2");

  const L = leggiNumero(lunghezza)||0;
  const La = leggiNumero(larghezza)||0;
  const P = leggiNumero(profondita)||0;
  const fatt = leggiNumero(fattoreGonfiamento)||1;

  const volumeInSito = L*La*P;
  const volumeGonfio = volumeInSito*fatt;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:12 }}>
        <div>
          <label style={lbl}>Lunghezza (m)</label>
          <input value={lunghezza} onChange={e=>setLunghezza(e.target.value)} style={inp} placeholder="Es. 10"/>
        </div>
        <div>
          <label style={lbl}>Larghezza (m)</label>
          <input value={larghezza} onChange={e=>setLarghezza(e.target.value)} style={inp} placeholder="Es. 5"/>
        </div>
        <div>
          <label style={lbl}>Profondità (m)</label>
          <input value={profondita} onChange={e=>setProfondita(e.target.value)} style={inp} placeholder="Es. 1.5"/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Fattore di gonfiamento del materiale scavato</label>
        <input value={fattoreGonfiamento} onChange={e=>setFattoreGonfiamento(e.target.value)} style={inp}/>
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around" }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Volume in sito</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#374151" }}>{volumeInSito>0 ? volumeInSito.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"} m³</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Volume gonfio (da smaltire)</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#15803d" }}>{volumeInSito>0 ? volumeGonfio.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"} m³</div>
          </div>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Il materiale scavato occupa più volume di quello in sito (tipicamente 1,1-1,3× a seconda del terreno) — utile per stimare il numero di viaggi/cassoni di smaltimento.
      </div>

      <button onClick={()=>{setLunghezza("");setLarghezza("");setProfondita("");setFattoreGonfiamento("1.2");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
